import React from "react";
import PropTypes from "prop-types";
import _ from "lodash";

const Pagination = ({ itemsCount, pageSize, currentPage, onPageChange }) => {
  const pagesCount = Math.ceil(itemsCount / pageSize);
  if (pagesCount === 1) return null;

  const maxPagesToShow = 10;
  const startPage = Math.max(1, currentPage - Math.floor(maxPagesToShow / 2));
  const endPage = Math.min(pagesCount, startPage + maxPagesToShow - 1);

  const pages = _.range(startPage, endPage + 1);

  const renderPage = (page) => (
    <li key={page} className={page === currentPage? "page-item active" : "page-item"}>
      <a className="page-link" onClick={() => onPageChange(page)}>
        {page}
      </a>
    </li>
  );

  const renderFirstButton = () => (
    <li className="page-item">
      <a className="page-link" onClick={() => onPageChange(1)}>
        <i className="fa fa-angle-double-left" />
      </a>
    </li>
  );

  const renderLastButton = () => (
    <li className="page-item">
      <a className="page-link" onClick={() => onPageChange(pagesCount)}>
        <i className="fa fa-angle-double-right" />
      </a>
    </li>
  );

  const renderPreviousButton = () => (
    <li className="page-item">
      <a className="page-link" onClick={() => onPageChange(currentPage - 1)}>
        <i className="fa fa-angle-left" />
      </a>
    </li>
  );

  const renderNextButton = () => (
    <li className="page-item">
      <a className="page-link" onClick={() => onPageChange(currentPage + 1)}>
        <i className="fa fa-angle-right" />
      </a>
    </li>
  );

  return (
    <nav>
      <ul className="pagination d-flex justify-content-center">
        {currentPage > 1 && renderFirstButton()}
        {currentPage > 1 && renderPreviousButton()}
        {pages.map(renderPage)}
        {currentPage < pagesCount && renderNextButton()}
        {currentPage < pagesCount && renderLastButton()}
      </ul>
    </nav>
  );
};

Pagination.propTypes = {
  itemsCount: PropTypes.number.isRequired,
  pageSize: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired
};

export default Pagination;